<template>
    <div class="content">
        <div v-if="isClient && dashboardLoaded" class="select-container-dashboard">
            <ReglePastille cle="dashboard.personnalisableClientUniquement" />
            <div class="img-container-modifier">
                <ButtonWhite
                    id="bouton-modifier-dashboard"
                    :onClick="() => (plusActionOuvert = !plusActionOuvert)"
                    :start-tour="tourEnCours"
                    :text="$t('editable.input.edit')"
                    class="bouton-modifier"
                    @starttour="startTour"
                />
                <div v-if="plusActionOuvert" class="drop-container" role="menu">
                    <div
                        id="editer-dashboard"
                        class="edition-dashboard"
                        role="menuitem"
                        tabindex="0"
                        @click="editer"
                        @keyup.enter="editer"
                    >
                        {{ $t('dashboard.parametrable.editer') }}
                    </div>
                    <div
                        class="edition-dashboard"
                        role="menuitem"
                        tabindex="0"
                        @click="dupliquer"
                        @keyup.enter="dupliquer"
                    >
                        {{ $t('dashboard.parametrable.dupliquer') }}
                    </div>
                    <div
                        class="edition-dashboard texte-rouge"
                        role="menuitem"
                        tabindex="0"
                        @click="supprimer"
                        @keyup.enter="supprimer"
                    >
                        {{ $t('dashboard.parametrable.supprimer') }}
                        <ReglePastille cle="dashboard.suppressionFavoriInterdite" />
                    </div>
                </div>
            </div>
            <div id="liste-deroulante">
                <DropDown
                    :display="displayDashboard"
                    :label-creation="$t('dashboard.parametrable.ajout.dashbboard')"
                    :label-vide="$t('dashboard.parametrable.liste.vide')"
                    :list="listeDashboard"
                    :selected-item="selectedDashboard"
                    :width="'130%'"
                    class="select-dashboard-dropdown"
                    label=""
                    @creation="creerDashboard"
                    @select="setSelectedDashboard"
                />
                <ReglePastille cle="dashboard.dashboardAffichePardDefaut" />
            </div>
            <img
                :alt="$t('dashboard.parametrable.modale.info.favori')"
                :src="loadIconFavori"
                class="icon cursor-pointer"
                role="button"
                tabindex="0"
                @click="mettreFavori"
                @keyup.enter="mettreFavori"
            />
            <ReglePastille cle="dashboard.favoriIrreversibleIci" />
            <div class="info-icon-wrapper">
                <img
                    id="image-info"
                    :alt="$t('dashboard.parametrable.edition.titre')"
                    :src="loadInfoIcon"
                    class="cursor-pointer"
                    role="button"
                    tabindex="0"
                    @click="startOnBoarding"
                    @keyup.enter="startOnBoarding"
                />
                <div v-if="tooltipVisible && !actualitesOpen" class="custom-tooltip">
                    {{ $t('dashboard.tooltip.home') }}
                </div>
            </div>
        </div>
        <Modal v-if="isModaleOpen" @cancel="cancel">
            <div class="container-modale">
                <h2>
                    {{ $t('dashboard.choix.portail.titre') }}
                    <ReglePastille cle="dashboard.choixPortailModale" />
                </h2>
                <div class="center">
                    <button id="bouton-choix-portail-client" class="bouton bouton-client" @click="goToHomePage">
                        {{ $t('dashboard.choix.portail.client') }}
                    </button>
                    <button class="bouton bouton-fournisseur" @click="goToDashboardFournisseur">
                        {{ $t('dashboard.choix.portail.fournisseur') }}
                    </button>
                </div>
            </div>
        </Modal>
        <HomeMain v-else-if="isConnected && !modeEdition && dashboardLoaded" />
        <EditionDashboard v-if="modeEdition && isConnected" />
        <Modal v-if="modaleCreationDashboardOuverte" @cancel="modaleCreationDashboardOuverte = false">
            <ModaleCreationDashboard
                v-bind="dashboardADupliquer ? { dashboardADupliquer } : {}"
                @cancel="modaleCreationDashboardOuverte = false"
                @creation-dashboard-success="dashboardCreationSuccess"
                @duplication-dashboard-success="dashboardCreationSuccess(true)"
            ></ModaleCreationDashboard>
        </Modal>
        <Modal v-if="modaleAlerte" @cancel="modaleAlerte = false">
            <div class="container-modale">
                {{ texteAlerte }}
            </div>
        </Modal>
        <LoaderComponent v-if="isLoading || !dashboardLoaded" class="loader" />
        <ReglesMenusPanneau />
    </div>
</template>

<script lang="ts">
import { defineComponent, nextTick } from 'vue';
import HomeMain from '@/modules/Home/components/HomeMain.vue';
import { store } from '@/plugins/store';
import Modal from '@/components/ui-components/Modal.vue';
import { MENU } from '@/components/layout/store/mutation-types';
import { MENU_FOURNISSEUR_SWITCH_CLIENT } from '@/components/layout/store/state';
import router from '@/router';
import { HomeAction } from '@/modules/Home/store/actions-types';
import DropDown from '@/components/ui-components/DropDown.vue';
import ButtonWhite from '@/components/ui-components/ButtonWhite.vue';
import ModaleCreationDashboard from '@/modules/Home/components/ModaleCreationDashboard.vue';
import { Dashboard } from '@/models/Dashboard';
import { HOME } from '@/modules/Home/store/mutation-types';
import EditionDashboard from '@/modules/Home/pages/EditionDashboard.vue';
import LoaderComponent from '@/components/ui-components/LoaderComponent.vue';
import { SiteListActions } from '@/modules/SiteList/store/action-types';
import { SiteSearchDTO } from '@/modules/SiteList/service/SiteListService';
import TourService from '@/common/utils/TourService';
import ReglePastille from '@/components/regles/ReglePastille.vue';
import ReglesMenusPanneau from '@/components/regles/ReglesMenusPanneau.vue';

interface Data {
    isClientAndFournisseur: boolean;
    listeWidget: any;
    listeDashboard: Dashboard[];
    modaleCreationDashboardOuverte: boolean;
    dashboardLoaded: boolean;
    modaleAlerte: boolean;
    plusActionOuvert: boolean;
    dashboardADupliquer?: Dashboard;
    texteAlerte: string;
    modeEdition: boolean;
    tourEnCours: boolean;
    tooltipVisible: boolean;
}

export default defineComponent({
    name: 'Home',
    components: {
        ButtonWhite,
        LoaderComponent,
        EditionDashboard,
        ModaleCreationDashboard,
        DropDown,
        Modal,
        HomeMain,
        ReglePastille,
        ReglesMenusPanneau,
    },
    data(): Data {
        return {
            isClientAndFournisseur:
                localStorage.getItem('isFournisseur') === 'true' && localStorage.getItem('isClient') === 'true',
            listeWidget: [
                { name: 'widget1', id: 1, position: 0 },
                { name: 'widget2', id: 2, position: 1 },
            ],
            listeDashboard: [],
            modaleCreationDashboardOuverte: false,
            dashboardLoaded: false,
            modaleAlerte: false,
            plusActionOuvert: false,
            dashboardADupliquer: undefined,
            texteAlerte: '',
            modeEdition: false,
            tourEnCours: false,
            tooltipVisible: true,
        };
    },
    async mounted() {
        this.$store.dispatch(`siteList/${SiteListActions.GET_SITE_LIST}`, new SiteSearchDTO(0, '', true));
        document.addEventListener('click', this.close);
        if (this.$store.getters.getModalChoixPortailOuverte == null) {
            this.$store.commit(HOME.SET_MODAL_CHOIX_PORTAIL_OUVERTE, this.isClientAndFournisseur);
        }

        const jwtToken = localStorage.getItem('token_portail_partenaire');
        if (jwtToken && localStorage.getItem('botActive') !== 'true') {
            const botScript = document.createElement('script');
            botScript.setAttribute(
                'src',
                'https://storage.googleapis.com/ideta-prod.appspot.com/bots/-O4oH__QZ9sdXcHTH5OC/scripts/integration-web.js?GoogleAccessId=firebase-adminsdk-4b3yf%40ideta-prod.iam.gserviceaccount.com&Expires=16447017600&Signature=kMpAB4VeZ%2Bbh8OFLolxamhrOJ7zJt8vz2uKR0K%2BRv8%2BmS5haRuQIxrqstVfWqXRNquFMV73OvUjArfw2KWPhBKBVNQe48D%2BfiUomlWhL%2BbBoCnOmmA2jlrNM3mtxF%2B8CcuZHmq4xtcQYj4LG3XLefiVS0dkPSBg0eh3pfO1qGF%2FC6igMtxW0M4FObdLVOzz2RzUuxcbDFN6dj1fBm8%2BF1TsBpjvJeudySvn6yFoLKQ9dwnOc1bYymNSeE%2F5B3K6okhq4k6X9eczVmbaa88%2F7XSiklqgBysyZRDY15JN9yHZRy%2F%2FN3ybMs4K6uIpVFGnYnTu8%2BDnXnsFwKlw374Ti2Q%3D%3D'
            );
            botScript.setAttribute('type', 'text/javascript');
            botScript.setAttribute('async', '');
            document.head.appendChild(botScript);
            localStorage.setItem('botActive', 'true');
        }
        if (!this.isClientAndFournisseur) {
            if (localStorage.getItem('isClient') === 'true') {
                store.commit(`menuState/${MENU.SET_CHOIX_MENU}`, 'client');
            } else {
                store.commit(`menuState/${MENU.SET_CHOIX_MENU}`, 'fournisseur');
            }
        }
        await store.dispatch(HomeAction.GET_DASHBOARDS).then((dashboards: Dashboard[]) => {
            this.listeDashboard = dashboards;
        });
        this.dashboardLoaded = true;
    },
    computed: {
        actualitesOpen(): boolean {
            return this.$store.getters.getActualiteOpen;
        },
        isConnected(): boolean {
            return store.state.authState.token !== '' && store.state.authState.token !== null;
        },
        isModaleOpen(): boolean {
            return store.getters['menuState/getChoixMenu'] === undefined && this.isClientAndFournisseur;
        },
        selectedDashboard(): Dashboard {
            return store.getters.getSelectedDashboard;
        },
        loadIconMore() {
            return require('@/assets/img/icons/more.png');
        },
        loadIconFavori() {
            if (this.selectedDashboard !== undefined && this.selectedDashboard.favori) {
                return require('@/assets/img/icons/favoriVioletRempli.png');
            }
            return require('@/assets/img/icons/favoriVioletVide.png');
        },
        loadInfoIcon() {
            return require('@/assets/img/info_24dp.png');
        },
        isClient() {
            return store.getters['menuState/getChoixMenu'] === 'client';
        },
        isLoading() {
            return this.$store.getters.getEnregistrementsDashboardEnCours;
        },
    },
    methods: {
        startOnBoarding() {
            this.tourEnCours = true;
            this.$store.commit(`menuState/${MENU.SET_ONBOARDING_OPEN}`, true);
        },
        startTour(): void {
            nextTick(() => {
                TourService.initTour('Précédent', 'Fermer', 'Suivant', () => {
                    this.tourEnCours = false;
                    this.$store.commit(`menuState/${MENU.SET_ONBOARDING_OPEN}`, false);
                });

                TourService.addStep(
                    "Faites ici, rapidement, une <br>demande de devis ou d'intervention.",
                    '#bouton-demande-devis',
                    'top',
                    true,
                    false,
                    true
                );

                TourService.addStep(
                    'Accédez aux informations<br>de votre compte.',
                    '#bouton-mon-compte',
                    'bottom',
                    true,
                    false,
                    true
                );

                TourService.addStep(
                    'Cliquez sur Modifier<br>pour personnaliser<br>votre tableau de bord<br>et ses widgets.',
                    '#bouton-modifier-dashboard',
                    'bottom',
                    true,
                    false,
                    true
                );

                TourService.addStep(
                    "Retrouvez ici tous vos tableaux de bord<br>et la possibilité d'en créer un nouveau.",
                    '#liste-deroulante',
                    'bottom',
                    true,
                    true,
                    true
                );

                TourService.startTour();
            });
        },
        cancel(): void {
            store.commit(`menuState/${MENU.SET_CHOIX_MENU}`, 'client');
        },
        goToHomePage(): void {
            store.commit(`menuState/${MENU.SET_CHOIX_MENU}`, 'client');
            this.$store.commit(HOME.SET_MODAL_CHOIX_PORTAIL_OUVERTE, false);
        },
        goToDashboardFournisseur(): void {
            store.dispatch(HomeAction.SET_ACTUALITE_OPEN, false);
            this.$store.commit(HOME.SET_MODAL_CHOIX_PORTAIL_OUVERTE, false);
            router.push({ path: '/dashboard-fournisseur' }).then(() => {
                store.commit(`menuState/${MENU.SET_CHOIX_MENU}`, 'fournisseur');
                store.commit(`menuState/${MENU.SET_MENU}`, MENU_FOURNISSEUR_SWITCH_CLIENT);
            });
        },
        displayDashboard(dashboard: Dashboard) {
            return dashboard.libelle;
        },
        setSelectedDashboard(dashboard: Dashboard) {
            this.$store.commit(HOME.SET_SELECTED_DASHBOARD, dashboard);
        },
        dashboardCreationSuccess(duplication: boolean) {
            this.modaleCreationDashboardOuverte = false;
            store.dispatch(HomeAction.GET_DASHBOARDS).then((dashboards: Dashboard[]) => {
                this.listeDashboard = dashboards;
                this.$store.commit(HOME.SET_SELECTED_DASHBOARD, this.$store.getters.getCreatedDashboard);
            });
            if (!duplication) {
                this.$store.commit(HOME.OPEN_MODAL_WIDGET, true);
                this.$router.push({ path: '/edition-dashboard' });
            }
        },
        async mettreFavori() {
            if (this.selectedDashboard !== undefined) {
                if (this.selectedDashboard.favori) {
                    this.modaleAlerte = true;
                    this.texteAlerte = this.$t('dashboard.parametrable.modale.info.favori');
                } else {
                    this.selectedDashboard.favori = true;
                    await store.dispatch(HomeAction.PUT_DASHBOARD, this.selectedDashboard);
                    store.dispatch(HomeAction.GET_DASHBOARDS).then((dashboards: Dashboard[]) => {
                        this.listeDashboard = dashboards;
                    });
                }
            }
        },
        creerDashboard() {
            this.dashboardADupliquer = undefined;
            this.modaleCreationDashboardOuverte = true;
        },
        dupliquer() {
            this.dashboardADupliquer = this.selectedDashboard;
            this.modaleCreationDashboardOuverte = true;
        },
        async supprimer() {
            if (this.selectedDashboard !== undefined) {
                if (this.selectedDashboard.favori) {
                    this.modaleAlerte = true;
                    this.texteAlerte = this.$t('dashboard.parametrable.modale.info.suppression.favori');
                } else {
                    this.selectedDashboard.favori = false;
                    await store.dispatch(HomeAction.DELETE_DASHBOARD, this.selectedDashboard).then(() => {
                        store.dispatch(HomeAction.GET_DASHBOARDS).then((dashboards: Dashboard[]) => {
                            this.listeDashboard = dashboards;
                        });
                    });
                }
            }
        },
        editer() {
            router.push({ path: '/edition-dashboard' });
        },
        close(e: any) {
            if (this.tourEnCours) {
                return;
            }
            if (this.plusActionOuvert) {
                const buttonModifier = document.querySelector('.bouton-modifier');
                const dropContainer = document.querySelector('.drop-container');

                // Vérifier si le clic n'est ni sur le bouton, ni à l'intérieur du menu déroulant
                if (
                    e.target !== buttonModifier &&
                    !buttonModifier?.contains(e.target) &&
                    (!dropContainer || !dropContainer.contains(e.target))
                ) {
                    this.plusActionOuvert = false;
                }
            }

            // Gestion du tooltip info
            if (this.tooltipVisible) {
                const infoIcon = this.$el.querySelector('#image-info');
                const tooltipWrapper = this.$el.querySelector('.info-icon-wrapper');

                if (
                    e.target.id !== 'bouton-choix-portail-client' &&
                    e.target !== infoIcon &&
                    !infoIcon?.contains(e.target) &&
                    (!tooltipWrapper || !tooltipWrapper.contains(e.target))
                ) {
                    this.tooltipVisible = false;
                }
            }
        },
    },
});
</script>

<style scoped>
.content {
    box-sizing: border-box;
    display: flex;
    height: 100%;
}
@media screen and (min-width: 980px) {
    .content {
        display: block;
    }
}
.container-modale {
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
    padding: 30px 30px 15px 30px;
}
.bouton-client {
    background-color: var(--header-blue);
}
.bouton-fournisseur {
    background-color: var(--orange-fournisseur);
}
.bouton {
    border-radius: 2px;
    border: none;
    margin: 10px;
    height: 10vh;
    width: 45%;
    color: white;
    cursor: pointer;
}
.center {
    display: flex;
    justify-content: center;
}
.select-dashboard-dropdown {
    height: 32px !important;
    width: 350px;
    cursor: pointer;
    z-index: 7;
    padding: 3px 12px !important;
    box-sizing: border-box !important;
    border-radius: 4px !important;
    color: var(--color-principal) !important;
    background-color: var(--white) !important;
}
.select-dashboard-dropdown :deep(p) {
    margin: 0;
}
.bouton-modifier {
    height: 32px !important;
    box-sizing: border-box !important;
    border-radius: 4px !important;
    padding: 0 16px;
    cursor: pointer;
    font-family: 'Roboto';
    font-weight: 400;
    font-size: var(--font-size-low-medium);
    border: 1px solid #2e4de6 !important;
    color: var(--color-principal) !important;
    background-color: var(--white) !important;
}
.img-container-modifier {
    position: relative;
    z-index: 7;
}
.select-container-dashboard {
    display: flex;
    flex-direction: row-reverse;
    gap: 10px;
    margin-bottom: 20px;
    align-items: center;
    padding-right: 35px;
}
:deep(.label-active) {
    display: none;
}
:deep(.label) {
    display: none;
}
.icon {
    height: fit-content;
}
.drop-container {
    cursor: pointer;
    max-height: 250px;
    overflow: visible;
    z-index: 10;
    width: 200px;
    background-color: var(--white);
    position: absolute;
    top: 39px;
    right: 0;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
}
.img-container {
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: space-between;
    border-radius: 4px;
    padding: 11px 12px;
    align-items: center;
    font-weight: 400;
    font-size: var(--font-size-low-medium);
}
.drop-container {
    border-radius: 8px;
}
.edition-dashboard {
    margin: 10px;
}

h2 {
    display: block;
    font-size: 1.5em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    color: var(--color-principal);
}
</style>
